import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import IconClose from '../images/close.inline.svg'
import './style'

class TextCategorizationFragment extends Component {
	constructor(props) {
		super(props)

		this.state = {
			top: null,
			left: null,
		}
	}

	componentDidMount() {
		this.updatePosition()
	}

	updatePosition() {
		const { top: fTop, left: fLeft } = this.fake.getBoundingClientRect()
		const { top: pTop, left: pLeft } = this.props.parent

		this.setState({
			top: fTop - pTop,
			left: fLeft - pLeft,
		})
	}

	render() {
		const {
			text,
			index,
			id,
			range,
			onRemove,
			classList,
			itemNumber,
			disabled,
		} = this.props

		const {
			top,
			left,
		} = this.state

		const classNames = [
			'text-value-range',
			...classList,
		].join(' ')

		const button = itemNumber === undefined || itemNumber === null
			? (
				<button
					className={`text-value-close text-value-close__idx-${index}`}
					style={{ top, left }}
					onClick={() => { onRemove(id) }}
				>
					{
						disabled
							? ''
							: <IconClose />
					}
				</button>
			)
			: (
				<button
					className={`text-value-close text-value-close__idx-${index}`}
					style={{ top, left }}
				>
					{itemNumber}
				</button>
			)

		return (
			<Fragment>
				<p className={classNames}>
					{text.slice(0, range.start)}

					<span className={`text-value-range__selection text-value-range__idx-${index}`}>
						{text.slice(range.start, range.finish)}

						<strong
							className="text-value-range__closefaker"
							ref={(c) => { this.fake = c }}
						/>
					</span>

					{text.slice(range.finish)}
				</p>

				{button}
			</Fragment>
		)
	}
}

TextCategorizationFragment.defaultProps = {
	classList: [],
	itemNumber: null,
	disabled: false,
}

TextCategorizationFragment.propTypes = {
	range: PropTypes.object.isRequired,
	text: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	// index: PropTypes.number.isRequired,
	disabled: PropTypes.bool,
	index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	parent: PropTypes.object.isRequired,
	onRemove: PropTypes.func.isRequired,
	classList: PropTypes.array,
	itemNumber: PropTypes.number,
}

export default TextCategorizationFragment
